import { render, staticRenderFns } from "./NoInformation.vue?vue&type=template&id=b974b792&scoped=true&"
import script from "./NoInformation.vue?vue&type=script&lang=js&"
export * from "./NoInformation.vue?vue&type=script&lang=js&"
import style0 from "./NoInformation.vue?vue&type=style&index=0&id=b974b792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b974b792",
  null
  
)

export default component.exports